// Import Swiper styles
import { useContext } from "react";
import "swiper/css";
import "swiper/css/navigation";
import GlobalState from "../contexts/GlobalState";

export default function Report({
  report,
  index,
  images,
  setImages,
  show,
  setShow,
}) {
  const handleOpenLightbox = (report) => {
    if (!report.images.length) return;
    setImages(report.images_path);
    setShow(true);
  };

  const { generalDataGlobal } = useContext(GlobalState);

  return (
    <>
      <div key={index} className="col-md-4 col-sm-6 pdf-col position-relative ">
        {report?.pdf || report?.external_link ? (
          <a
            href={
              report.pdf
                ? process.env.REACT_APP_BASE_URL + report.pdf
                : report.external_link
            }
            className="pdf-hover"
            target="_blank"
            rel="noreferrer"
            download
          >
            <div className="position-relative">
              <div className="report-content position-relative shadow ">
                <div
                  className="pdf-image ratio ratio-1x1"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="pdf-overlay position-absolute">
                    <div className=" pdf-title position-relative">
                      <p className="position-absolute col-8">{report.title}</p>
                    </div>
                    <div className="pdf-download position-absolute">
                      <svg
                        width="41"
                        height="41"
                        viewBox="0 0 41 41"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20.5 27.4331L12.1667 19.0998L14.5 16.6831L18.8334 21.0164V7.43311H22.1667V21.0164L26.5 16.6831L28.8334 19.0998L20.5 27.4331ZM10.5 34.0998C9.58335 34.0998 8.79891 33.7737 8.14669 33.1214C7.49446 32.4692 7.1678 31.6842 7.16669 30.7664V25.7664H10.5V30.7664H30.5V25.7664H33.8334V30.7664C33.8334 31.6831 33.5072 32.4681 32.855 33.1214C32.2028 33.7748 31.4178 34.1009 30.5 34.0998H10.5Z"
                          fill={`${generalDataGlobal[0]?.general?.secondary_color}`}
                        />
                      </svg>
                    </div>
                  </div>

                  <img
                    src={
                      report.image
                        ? process.env.REACT_APP_BASE_URL + report.image
                        : "/assets/images/PDF.svg"
                    }
                    className={report.image ? "cover-pdf" : "default-pdf"}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </a>
        ) : (
          <div
            className="position-relative pointer"
            onClick={() => handleOpenLightbox(report)}
          >
            <div className="report-content position-relative shadow ">
              <div
                className="pdf-image ratio ratio-1x1"
                style={{ backgroundColor: "white" }}
              >
                <div className="pdf-overlay position-absolute">
                  <div className=" pdf-title position-relative">
                    <p className="position-absolute col-8">{report.title}</p>
                  </div>
                </div>

                <img
                  src={
                    report.image
                      ? process.env.REACT_APP_BASE_URL + report.image
                      : "/assets/images/PDF.svg"
                  }
                  className={report.image ? "cover-pdf" : "default-pdf"}
                  alt=""
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
